interface UserIconProps {
  color?: string;
}

const UserIcon = ({ color }: UserIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9999 17.5V15.8333C14.9999 15.1703 14.7363 14.5346 14.2675 14.0657C13.8573 13.6556 13.3195 13.4024 12.7473 13.3455L12.4999 13.3333H7.49992C6.83688 13.3333 6.20118 13.5969 5.73234 14.0657C5.2635 14.5346 4.99992 15.1703 4.99992 15.8333V17.5C4.99992 17.9602 4.62682 18.3333 4.16659 18.3333C3.70635 18.3333 3.33325 17.9602 3.33325 17.5V15.8333C3.33325 14.7283 3.77255 13.6688 4.55396 12.8874C5.33536 12.106 6.39485 11.6667 7.49992 11.6667H12.4999L12.7066 11.6715C13.7364 11.7226 14.7133 12.1548 15.4459 12.8874C16.2273 13.6688 16.6666 14.7283 16.6666 15.8333V17.5C16.6666 17.9602 16.2935 18.3333 15.8333 18.3333C15.373 18.3333 14.9999 17.9602 14.9999 17.5Z"
        fill={color ?? "#313131"}
      />
      <path
        d="M12.4999 5.83332C12.4999 4.45261 11.3806 3.33332 9.99992 3.33332C8.61921 3.33332 7.49992 4.45261 7.49992 5.83332C7.49992 7.21404 8.61921 8.33332 9.99992 8.33332C11.3806 8.33332 12.4999 7.21404 12.4999 5.83332ZM14.1666 5.83332C14.1666 8.13451 12.3011 9.99999 9.99992 9.99999C7.69873 9.99999 5.83325 8.13451 5.83325 5.83332C5.83325 3.53214 7.69873 1.66666 9.99992 1.66666C12.3011 1.66666 14.1666 3.53214 14.1666 5.83332Z"
        fill={color ?? "#313131"}
      />
    </svg>
  );
};

export default UserIcon;
